import { Tooltip } from 'antd';
import './index.scss';
import { TButtonCustom } from './interface/interface';

const ButtonAgreeWhite = ({ value, type = 'normal', ...props }: TButtonCustom) => {
  const buttonElement = (
    <button
      className={`button-agree-white ${type} ${props.disabled ? 'disabled' : ''} ${props.subClass || ''}`}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {value}
    </button>
  );

  return props.disabled && props.disabledTooltip ? (
    <Tooltip
      title={props.disabledTooltip}
      placement="bottom"
      color="#FFF"
      overlayInnerStyle={{ color: '#514B4D', fontSize: '12px', fontWeight: 500 }}
    >
      <span>{buttonElement}</span>
    </Tooltip>
  ) : (
    buttonElement
  );
};
export default ButtonAgreeWhite;
